/**
 * Search-result meta of the public pages in Spanish (ADR-0062): the /es/… pages. The English source is PUBLIC_PAGES in
 * app/publicRoutes.ts; title ≤ 60 characters, description ≤ 155 (publicRoutes.test.ts). A legal page's title is the
 * document's own title (es/legal-docs) with the brand.
 */
export default {
  "/": {
    title: "Funded Lime — challenges de prop: cripto, FX y futuros",
    description: "Supera un challenge en una cuenta simulada con datos de mercado reales y obtén financiación. Cripto, FX y futuros CME, reglas públicas, payouts hasta 90%.",
    ogTitle: "Funded Lime — Exprime el mercado",
    ogDescription: "Challenges de prop trading en cripto, FX y futuros con datos de mercado reales. Reglas públicas, cada ejecución explicada, payouts de hasta 90%.",
  },
  "/programs": {
    title: "Challenges de prop trading y precios · Funded Lime",
    description: "Arma tu challenge: perpetuos cripto, FX/CFD o futuros CME; Instant, 1 fase, 2 fases o sprint. Todas sus reglas y todos sus precios, por adelantado.",
  },
  "/faq": {
    title: "Preguntas y respuestas de prop trading · Funded Lime",
    description: "¿Es dinero real? Cómo se ejecutan las órdenes, cuándo cierra el día de trading, si cambian las reglas, qué pasa si fallan los datos y cómo son los payouts.",
  },
  "/legal/terms": {
    title: "Términos y condiciones · Funded Lime",
    description: "El acuerdo entre tú y Funded Lime: qué vendemos, cómo funcionan las evaluaciones y las cuentas funded, qué no está permitido y qué pasa si algo sale mal.",
  },
  "/legal/refunds": {
    title: "Política de pagos y reembolsos · Funded Lime",
    description: "Cómo pagas un programa de Funded Lime en cripto, qué pasa cuando un pago sale mal y cuándo se devuelve una tarifa.",
  },
  "/legal/payouts": {
    title: "Política de payouts · Funded Lime",
    description: "Cuándo una cuenta funded paga, cuánto, adónde va y por qué una solicitud de payout puede rechazarse.",
  },
  "/legal/prohibited": {
    title: "Prácticas de trading prohibidas · Funded Lime",
    description: "El trading que aprovecha la simulación o las reglas en lugar de demostrar habilidad, y que no está permitido en las cuentas de Funded Lime.",
  },
  "/legal/aml": {
    title: "Política AML y KYC · Funded Lime",
    description: "Cómo Funded Lime mantiene la plataforma a salvo del lavado de dinero, la financiación del terrorismo, la evasión de sanciones y el fraude.",
  },
  "/legal/privacy": {
    title: "Política de privacidad · Funded Lime",
    description: "Qué datos personales recopila Funded Lime, para qué, quién más los ve, cuánto tiempo los conservamos y qué puedes pedirnos.",
  },
  "/legal/cookies": {
    title: "Política de cookies · Funded Lime",
    description: "Qué cookies y qué almacenamiento del navegador usa Funded Lime, para qué y cómo eliges.",
  },
  "/legal/risk": {
    title: "Divulgación de riesgos · Funded Lime",
    description: "Lee antes de comprar: todas las cuentas de Funded Lime son simuladas. Qué significan los resultados simulados y qué no.",
  },
  "/legal/execution": {
    title: "Política de ejecución · Funded Lime",
    description: "Cómo el motor de Funded Lime ejecuta las órdenes de cuentas simuladas con datos de mercado reales: latencia, barrido del libro, spread, comisiones.",
  },
};
